// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let Callout = require("../common/Components/Callout.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let Redirect = require("../../reason/common/Redirect.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Link = require("next/link").default;
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ShareAgentMarketingProfileDialog = require("./ShareAgentMarketingProfileDialog.bs.js");
let AgentMarketingProfileSettingsQuery_graphql = require("../../__generated__/AgentMarketingProfileSettingsQuery_graphql.bs.js");
let AgentMarketingProfileSettings_page_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.bs.js");
let AgentMarketingProfileSettings_header_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.bs.js");
let AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.bs.js");

let convertFragment = AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentMarketingProfileSettings$Header(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileSettings_header_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = React.useState(() => false);
  let setShareModalShown = match[1];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(ShareAgentMarketingProfileDialog.make, {
        marketingProfile: marketingProfile.fragmentRefs,
        isOpen: match[0],
        onDismiss: () => setShareModalShown(param => false)
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h2", {
            children: "Marketing Profile",
            className: "text-zinc-800 text-3xl font-medium leading-6",
            id: "marketing-profile-settings-title"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("p", {
              children: "The Marketing Profile is a public page that others can search for or that you can share to promote and showcase the value of your TAN membership."
            }),
            className: "space-y-1 text-base max-w-2xl text-zinc-500"
          })
        ],
        className: "space-y-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            onClick: param => setShareModalShown(param => true),
            className: "",
            children: "Share Profile"
          }),
          JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
            href: Scalars.URL.toString(marketingProfile.publicUrl),
            target: "_blank",
            children: "View Profile"
          })
        ],
        className: "flex flex-row gap-4"
      })
    ],
    className: "flex flex-col justify-between lg:flex-row lg:items-end gap-8 border-b pb-6"
  });
}

let Header = {
  Fragment: Fragment,
  make: AgentMarketingProfileSettings$Header
};

let convertFragment$1 = AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToPhotos(props) {
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsx(ButtonsV5.Link.make, {
      href: "/account/marketing_profile/photos",
      children: JsxRuntime.jsx("span", {
        children: props.text,
        className: "underline"
      })
    })
  });
}

let LinkToPhotos = {
  make: AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToPhotos
};

function AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToAboutSection(props) {
  return JsxRuntime.jsx("li", {
    children: JsxRuntime.jsx(ButtonsV5.Link.make, {
      href: "/account/marketing_profile/about",
      children: JsxRuntime.jsx("span", {
        children: props.text,
        className: "underline"
      })
    })
  });
}

let LinkToAboutSection = {
  make: AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToAboutSection
};

function AgentMarketingProfileSettings$IncompleteProfileCallout(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileSettings_incompleteProfileCallout_agentMarketingProfile_graphql.node, convertFragment$1, props.marketingProfile);
  let specialties = marketingProfile.specialties;
  let profilePicture = marketingProfile.profilePicture;
  let featuredPhoto = marketingProfile.featuredPhoto;
  let bio = marketingProfile.bio;
  let __x = profilePicture !== undefined && featuredPhoto !== undefined && bio !== undefined ? specialties === undefined : true;
  return ReactRender.ifTrue(JsxRuntime.jsx(Callout.Info.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Your marketing profile is active but appears to be lacking some content. Follow these steps to improve it:"
        }),
        JsxRuntime.jsxs("ul", {
          children: [
            profilePicture !== undefined ? (
                featuredPhoto !== undefined ? null : JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToPhotos, {
                    text: "Add your featured portrait."
                  })
              ) : (
                featuredPhoto !== undefined ? JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToPhotos, {
                    text: "Add your profile picture."
                  }) : JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToPhotos, {
                    text: "Add your profile picture and featured portrait."
                  })
              ),
            bio !== undefined ? (
                specialties !== undefined ? null : JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToAboutSection, {
                    text: "Add your specialties."
                  })
              ) : (
                specialties !== undefined ? JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToAboutSection, {
                    text: "Add your bio."
                  }) : JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout$LinkToAboutSection, {
                    text: "Add your bio and specialties."
                  })
              )
          ],
          className: "list-disc list-inside flex flex-col gap-2"
        })
      ],
      className: "flex flex-col gap-3"
    }),
    title: "Complete your marketing profile"
  }), __x);
}

let IncompleteProfileCallout = {
  Fragment: Fragment$1,
  LinkToPhotos: LinkToPhotos,
  LinkToAboutSection: LinkToAboutSection,
  make: AgentMarketingProfileSettings$IncompleteProfileCallout
};

function AgentMarketingProfileSettings$TeamCallout(props) {
  return JsxRuntime.jsx(Callout.Discovery.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Your current marketing profile is designed for a single agent. If you work on a team, click the button below to create a team profile instead. This will enable you to highlight all members of the team, regardless of whether they are additional users on this account.",
          className: "text-base leading-5"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
            href: "/account/team_marketing_profile/new",
            size: "small",
            children: "Create Team Profile",
            color: "TanBlue"
          })
        })
      ],
      className: "space-y-4"
    }),
    title: "Are you part of a team?"
  });
}

let TeamCallout = {
  make: AgentMarketingProfileSettings$TeamCallout
};

function AgentMarketingProfileSettings$SettingsLinks$Setting(props) {
  return JsxRuntime.jsxs(Link, {
    href: props.url,
    className: "border rounded-lg p-4 flex justify-between items-center",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.name,
            className: "text-zinc-800 text-base font-semibold"
          }),
          JsxRuntime.jsx("div", {
            children: props.description,
            className: "text-zinc-600"
          })
        ],
        className: "space-y-3"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(IconV5.make, {
          icon: "arrow-right",
          className: "h-4 w-4 text-zinc-600"
        })
      })
    ]
  });
}

let Setting = {
  make: AgentMarketingProfileSettings$SettingsLinks$Setting
};

function descriptionOfPage(page) {
  switch (page) {
    case "BasicInfo" :
      return "Update your name, license number, and website.";
    case "Photos" :
      return "Update your avatar and your featured portrait.";
    case "Bio" :
      return "Update your bio and specialties.";
    case "SocialMedia" :
      return "Link to your social media accounts.";
    case "Url" :
      return "Personalize the URL for your profile.";
  }
}

function AgentMarketingProfileSettings$SettingsLinks(props) {
  let subpages = MarketingProfileSubpages.useAgentProfilePages();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Update your profile",
            className: "text-zinc-800 text-2xl font-medium leading-6"
          }),
          JsxRuntime.jsx("p", {
            children: "Note that updating your Marketing Profile does not affect how you appear to other agents and clients on TAN. Your TAN Profile is what determines how you appear to others on the platform.",
            className: "text-base text-zinc-500"
          })
        ],
        className: "space-y-2"
      }),
      JsxRuntime.jsx("div", {
        children: subpages.map(page => JsxRuntime.jsx(AgentMarketingProfileSettings$SettingsLinks$Setting, {
          name: page.displayName,
          description: descriptionOfPage(page.page),
          url: page.path
        })),
        className: "space-y-6"
      })
    ],
    className: "space-y-6"
  });
}

let SettingsLinks = {
  Setting: Setting,
  descriptionOfPage: descriptionOfPage,
  make: AgentMarketingProfileSettings$SettingsLinks
};

function AgentMarketingProfileSettings$PlanCallout(props) {
  return JsxRuntime.jsx(Callout.Warning.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Upgrade to PRO to make your profile look even better."
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
            href: "/plans",
            size: "small",
            children: "Upgrade to PRO",
            color: "TanBlue"
          })
        })
      ],
      className: "flex flex-col gap-4"
    }),
    title: "You currently have a limited version of the marketing profile"
  });
}

let PlanCallout = {
  make: AgentMarketingProfileSettings$PlanCallout
};

function AgentMarketingProfileSettings$ChangeProfileTypeSection(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Switch to a team profile",
            className: "text-zinc-800 text-xl font-medium leading-6"
          }),
          JsxRuntime.jsx("p", {
            children: "Your current marketing profile is designed for a single agent. If you work on a team, click the button below to create a team profile instead.",
            className: "text-base text-zinc-500 "
          })
        ],
        className: "space-y-4"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
          href: "/account/team_marketing_profile/new",
          size: "small",
          children: "Create team profile"
        }),
        className: "space-y-4"
      })
    ],
    className: "space-y-4 border-t border-zinc-200 pt-6"
  });
}

let ChangeProfileTypeSection = {
  make: AgentMarketingProfileSettings$ChangeProfileTypeSection
};

let convertFragment$2 = AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function AgentMarketingProfileSettings$Page(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileSettings_page_agentMarketingProfile_graphql.node, convertFragment$2, props.marketingProfile);
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(AgentMarketingProfileSettings$Header, {
          marketingProfile: marketingProfile.fragmentRefs
        }),
        ReactRender.ifFalse(JsxRuntime.jsx(AgentMarketingProfileSettings$PlanCallout, {}), hasFullProfile),
        JsxRuntime.jsx(AgentMarketingProfileSettings$TeamCallout, {}),
        ReactRender.ifTrue(JsxRuntime.jsx(AgentMarketingProfileSettings$IncompleteProfileCallout, {
          marketingProfile: marketingProfile.fragmentRefs
        }), hasFullProfile),
        JsxRuntime.jsx(AgentMarketingProfileSettings$SettingsLinks, {}),
        JsxRuntime.jsx(AgentMarketingProfileSettings$ChangeProfileTypeSection, {})
      ],
      className: "space-y-6"
    }),
    className: "bg-white p-6 shadow-sm rounded space-y-8"
  });
}

let Page = {
  Fragment: Fragment$2,
  make: AgentMarketingProfileSettings$Page
};

let convertVariables = AgentMarketingProfileSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfileSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfileSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$3 = RescriptRelay_Query.useQuery(convertVariables, AgentMarketingProfileSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, AgentMarketingProfileSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfileSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(AgentMarketingProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(AgentMarketingProfileSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$3,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function AgentMarketingProfileSettings(props) {
  let match = use$3(undefined, undefined, undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  switch (marketingProfile.__typename) {
    case "AgentMarketingProfile" :
      return JsxRuntime.jsx(AgentMarketingProfileSettings$Page, {
        marketingProfile: marketingProfile.fragmentRefs
      });
    case "TeamMarketingProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/team_marketing_profile"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = AgentMarketingProfileSettings;

exports.Header = Header;
exports.IncompleteProfileCallout = IncompleteProfileCallout;
exports.TeamCallout = TeamCallout;
exports.SettingsLinks = SettingsLinks;
exports.PlanCallout = PlanCallout;
exports.ChangeProfileTypeSection = ChangeProfileTypeSection;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
